import { render, staticRenderFns } from "./SubmitForApprovalAction.vue?vue&type=template&id=23b9b3f2&"
import script from "./SubmitForApprovalAction.vue?vue&type=script&lang=js&"
export * from "./SubmitForApprovalAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports